import axios from 'axios';
import { apiPath } from '../utils/appPaths';

const API_BASE_URL = apiPath();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Boards API
export const boardsAPI = {
  getAll: (params = {}) => api.get('/boards', { params }),
  getById: (id) => api.get(`/boards/${id}`),
  getBoard: (id) => api.get(`/boards/${id}`),
  getSummary: (id) => api.get(`/boards/${id}?include_svg=0`),
  getSvg: (id) => api.get(`/boards/${id}/svg`),
  getPins: (id) => api.get(`/boards/${id}/pins`),
  getBoardPins: (id) => api.get(`/boards/${id}/pins`),
  updatePin: (pinId, data) => api.put(`/pins/${pinId}`, data),
  compare: (ids) => api.get('/boards/compare', { params: { ids } }),
};

// Pins API
export const pinsAPI = {
  getById: (id) => api.get(`/pins/${id}`),
};

// Pin Groups API
export const pinGroupsAPI = {
  getAll: () => api.get('/pin-groups'),
  getPinGroups: () => api.get('/pin-groups'),
};

// ICs API
export const icPinoutsAPI = {
  getAll: () => api.get('/ic-pinouts'),
  getBySlug: (slug) => api.get(`/ic-pinouts/${slug}`)
};

export const contactAPI = {
  submit: (data) => api.post('/contact', data),
};

export const guidesAPI = {
  getAll: () => api.get('/guides'),
  getBySlug: (slug) => api.get(`/guides/${slug}`),
};

export const projectBuilderAPI = {
  getSettings: () => api.get('/project-builder/settings'),
  getExamples: () => api.get('/project-builder/examples'),
};

export const adsAPI = {
  getAll: () => api.get('/ads'),
  getBySlot: (slotKey) => api.get(`/ads/${slotKey}`),
};

export default api;
